/* eslint-disable max-len */

'use strict';

const FR = {
	results: {
		caption: '#COUNT# résultats de recherche trouvés pour "#QUERY#"',
		moreResultsButton: 'Voir plus de résultats',
		noResultsText: 'Désolés, nous n\'avons trouvé aucun résultat pour votre recherche.',
		queryCorrectionText: 'Est-ce que vous vouliez dire "#CORRECTION#" ?',
		queryCorrectionRewrite: 'Résultats de recherche pour "#CORRECTION#"',
		orderByRelevanceText: 'Pertinence',
		sortingLabel: 'Tri :'
	},
	accessibility: {
		searchFieldLabel: 'Requête de recherche',
		srSuggestionsHiddenText: 'Les suggestions de recherche sont masquées',
		srNoSuggestionsText: 'Aucune suggestion de recherche',
		srSuggestionsCountText: '#COUNT# suggestions de recherche affichées',
		srOneSuggestionText: 'Une suggestion de recherche affichée',
		srSuggestBoxControlDescription: 'Utilisez les flèches haut et bas pour sélectionner le résultat disponible. Appuyez sur Entrée pour accéder au résultat de recherche sélectionné. Les utilisateurs d\'appareils tactiles peuvent se servir de gestes tels que toucher et glisser.'
	},
	smart404: {
		caption: 'Essayez plutôt ici :'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Tous les résultats',
			allResultsTabTitle: 'Tous les résultats (#COUNT#)'
		}
	},
	voiceSearch: {
		lang: 'fr-FR'
	},
	filters: {
		label: 'Filtre',
		deleteAllLabel: 'Tout effacer',
		toggleButtonLabel: 'Filtrer les résultats',
		multiSelectSearchLabel: 'Rechercher #FILTER_NAME#',
		multiSelectEmptyState: 'Aucun filtre correspondant',
		multiSelectShowMoreLabel: 'Voir #COUNT# en plus',
		multiSelectShowLessLabel: 'Voir moins d\'options',
		clearGroupLabel: 'Effacer',
		sliderMinUnitLabel: 'Min. #UNIT#',
		sliderMaxUnitLabel: 'Max. #UNIT#',
		submitButtonLabel: 'Envoyer'
	}
};

const DE = {
	results: {
		caption: '#COUNT# Suchergebnisse für "#QUERY#" gefunden',
		moreResultsButton: 'Weitere ansehen',
		noResultsText: 'Entschuldigung, wir haben keine Treffer auf Deine Suchanfrage gefunden.',
		queryCorrectionText: 'Hast du "#CORRECTION#" gemeint?',
		queryCorrectionRewrite: 'Ergebnisse für "#CORRECTION#" zeigen',
		orderByRelevanceText: 'Relevanz',
		sortingLabel: 'Sortierung:'
	},
	accessibility: {
		searchFieldLabel: 'Suchanfrage',
		srSuggestionsHiddenText: 'Suchvorschläge sind ausgeblendet',
		srNoSuggestionsText: 'Keine Suchvorschläge',
		srSuggestionsCountText: '#COUNT# angezeigte Suchvorschläge',
		srOneSuggestionText: 'Ein angezeigter Suchvorschlag',
		srSuggestBoxControlDescription: 'Verwende die Pfeile nach oben und unten, um das verfügbare Ergebnis auszuwählen. Drücke die Eingabetaste, um zum ausgewählten Suchergebnis zu gelangen. Benutzer von Touchgeräten können Touch- und Streichgesten verwenden.'
	},
	smart404: {
		caption: 'Versuch stattdessen das:'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Alle Ergebnisse',
			allResultsTabTitle: 'Alle Ergebnisse (#COUNT#)'
		}
	},
	voiceSearch: {
		lang: 'de'
	},
	filters: {
		label: 'Filter',
		deleteAllLabel: 'Alle zurücksetzen',
		toggleButtonLabel: 'Ergebnisse filtern',
		multiSelectSearchLabel: 'Suche #FILTER_NAME#',
		multiSelectEmptyState: 'Keine passenden Filteroptionen.',
		multiSelectShowMoreLabel: '#COUNT# weitere ansehen',
		multiSelectShowLessLabel: 'Weniger Optionen anzeigen',
		clearGroupLabel: 'leeren',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Max #UNIT#',
		submitButtonLabel: 'Anwenden'
	}
};

const NL = {
	results: {
		caption: 'We hebben #COUNT# resultaten gevonden voor "#QUERY#"',
		moreResultsButton: 'Meer resultaten',
		noResultsText: 'Sorry, we hebben geen resultaat gevonden voor jouw opdracht.',
		queryCorrectionText: 'Bedoelde je "#CORRECTION#"?',
		queryCorrectionRewrite: 'Toon resultaten voor "#CORRECTION#"',
		orderByRelevanceText: 'Relevantie',
		sortingLabel: 'Sorteren:'
	},
	accessibility: {
		searchFieldLabel: 'Zoekopdracht',
		srSuggestionsHiddenText: 'Zoekvoorstellen zijn verborgen',
		srNoSuggestionsText: 'Geen zoekvoorstellen',
		srSuggestionsCountText: '#COUNT# getoonde zoekvoorstellen',
		srOneSuggestionText: 'Een getoonde zoekvoorstel',
		srSuggestBoxControlDescription: 'Gebruik de pijlen omhoog en omlaag om het beschikbare resultaat te selecteren. Druk op enter om naar het geselecteerde zoekresultaat te gaan. Gebruikers van aanraakapparatuur kunnen aanraak- en veegbewegingen gebruiken.'
	},
	smart404: {
		caption: 'Probeer in plaats daarvan hierheen te gaan:'
	},
	layout: {
		navigation: {
			allResultsTabName: 'Alle Resultaten',
			allResultsTabTitle: 'Alle Resultaten (#COUNT#)'
		}
	},
	voiceSearch: {
		lang: 'nl'
	},
	filters: {
		label: 'Filter',
		deleteAllLabel: 'Verwijder alles',
		toggleButtonLabel: 'Filter resultaten',
		multiSelectSearchLabel: 'Zoek #FILTER_NAME#',
		multiSelectEmptyState: 'Geen passende filteropties.',
		multiSelectShowMoreLabel: 'Zie #COUNT# meer',
		multiSelectShowLessLabel: 'Minder opties zien',
		clearGroupLabel: 'Verwijder',
		sliderMinUnitLabel: 'Min #UNIT#',
		sliderMaxUnitLabel: 'Max #UNIT#',
		submitButtonLabel: 'Inzenden'
	}
};

const EN = {
	results: {
		caption: 'Found #COUNT# search results for "#QUERY#"', // the caption of the search results
		moreResultsButton: 'See more', // HTML for the more results button, all results will be shown if this is null
		noResultsText: 'Sorry, we have not found any matches for your query.', // the text to show when there are no results
		queryCorrectionText: 'Did you mean "#CORRECTION#"?', // #CORRECTION# will be replaced automatically by the corrected query
		queryCorrectionRewrite: 'Showing results for "#CORRECTION#"', // #CORRECTION## will be replaced automatically with the rewritten/corrected query
		orderByRelevanceText: 'Relevance', // the text to be shown in order select box to describe 'order by relevance' option
		sortingLabel: 'Sorting:', // a text label to show next to the sorting selection
	},
	accessibility: {
		searchFieldLabel: 'Search query', // invisible label to be used with screen readers when search field is focused, will only be used if value is not empty and there is no label element associated to the search field,default: 'Search input'
		srSuggestionsHiddenText: 'Search suggestions are hidden', // text to announce @screen reader after search suggestions have been hidden
		srNoSuggestionsText: 'No search suggestions', // text to announce @screen reader if no suggestions are available
		srSuggestionsCountText: '#COUNT# search suggestions shown', // text to announce @screen reader after search suggestions have been shown, #COUNT# will be replaced with the suggestion count
		srOneSuggestionText: 'One search suggestion shown', // text to announce @screen reader after search suggestions have been shown
		srSuggestBoxControlDescription: 'Use up and down arrows to select available result. Press enter to go to selected search result. Touch device users can use touch and swipe gestures.' // text to announce @screen reader after search input is focused - describes keyboard controls
	},
	smart404: {
		caption: 'Try going here instead:' // caption for 404 results
	},
	layout: {
		navigation: {
			allResultsTabName: 'All Results', // the name of the 'All Results' tab
			allResultsTabTitle: 'All Results (#COUNT#)' // the title of the all results group, e.g. 'Found 43 results for "curry"'
		}
	},
	voiceSearch: {
		lang: 'en-US'
	},
	filters: {
		label: 'Filter', // the label of the filter column, will be also used as screen reader text
		deleteAllLabel: 'Reset All', // the label of the "delete all" option
		toggleButtonLabel: 'Filter results', // the label of the filter toggle button,
		multiSelectSearchLabel: 'Search #FILTER_NAME#', // the label of multiselect search input
		multiSelectEmptyState: 'No matching filter options.', // the message to show if the filter option search yields empty results
		multiSelectShowMoreLabel: 'See #COUNT# more',
		multiSelectShowLessLabel: 'See fewer options',
		clearGroupLabel: 'clear', // the label of the clear all filter group options button
		sliderMinUnitLabel: 'Min #UNIT#', // label of the min val range slider input
		sliderMaxUnitLabel: 'Max #UNIT#', // label of the min val range slider input
		submitButtonLabel: 'Set' // the label of the submit filter button
	}
};

export default {
	FR,
	DE,
	NL,
	EN
};


// WEBPACK FOOTER //
// ./src/assets/LanguageStrings.js